import React from 'react';

// this is for hooks can be use on class base component
export default function (Component, controller) {
  return (props) => {
    const ctrler = controller(props);
    return <Component {...props} controller={ctrler} />;
  };
}
